import { createContext, use } from 'react'

type CustomerInfo = Record<string, unknown> | null
type BillingInfo = Record<string, unknown> | null
type CartData = Record<string, unknown> | null
type DeliveryAddress = Record<string, unknown>

export interface CheckoutContextType {
  customerInfo: CustomerInfo
  billingInfo: BillingInfo
  cartData: CartData
  shouldShowServiceCode: boolean
  isOrderReferenceMandatory: boolean
  isShippingNotesMandatory: boolean
  shouldDisableCheckout: boolean
  setDisableCheckout: (value: React.SetStateAction<boolean>) => void
  deliveryAddresses: DeliveryAddress[]
}

export const CheckoutContext = createContext<CheckoutContextType | null>(null)

export const useCheckoutContext = () => {
  const checkoutContext = use(CheckoutContext)

  if (checkoutContext === undefined) {
    throw new Error(
      'useCheckoutContext must be used within the CheckoutProvider',
    )
  }

  return checkoutContext
}
